import { useState, useEffect } from 'react';
import { getOrCreateClientId } from '../utils/clientId.js'

const SESSION_KEY = 'aitf_group_id';

export function useGroupContext(groupIdFromUrl) {
    const personalGroupId = `aitf_${getOrCreateClientId()}`;

    const [groupId, setGroupId] = useState(
        groupIdFromUrl ||
        sessionStorage.getItem(SESSION_KEY) ||
        personalGroupId
    );

    useEffect(() => {
        if (groupIdFromUrl) {
            sessionStorage.setItem(SESSION_KEY, groupIdFromUrl);
            setGroupId(groupIdFromUrl);
        }
    }, [groupIdFromUrl]);

    const isPersonal = groupId === personalGroupId;

    return { groupId, isPersonal };
}